import React, {PureComponent, ReactNode, StrictMode} from "react";
import {Transition} from "@headlessui/react";

export class KeyNumberApprovalSkeleton extends PureComponent {
    render(): ReactNode {
        return (
            <div className="w-full">
                <Transition
                    appear={true}
                    show={true}
                    enter={"transition transform duration-300 ease-out"}
                    enterFrom={"translate-x-4 opacity-0"}
                    enterTo={"translate-x-0 opacity-100"}
                    leave={"transition transform duration-300 ease-in"}
                    leaveFrom={"opacity-100"}
                    leaveTo={"opacity-0"}>
                    <StrictMode>
                        <div
                            className="w-full md:w-1/3 border-2 border-tertiary rounded-lg p-5 mt-6">
                            <div className="animate-pulse font-serif font-bold text-lg mb-1">
                                <div className="w-1/2 bg-black-300 h-6 mb-2 rounded-md"/>
                                <div className="w-full bg-black-300 h-6 mb-2 rounded-md"/>
                            </div>
                        </div>
                    </StrictMode>
                </Transition>
            </div>
        );
    }
}


